// The same scrubbing the worker does, repeated here for the memories already written.
//
// Workers AI occasionally appends its own envelope to a completion — `{"tool_calls": [],"p":"abcdef…"}`
// — and until the worker started stripping it, that scrap got sealed into the observation itself.
// The server cannot go back and fix those: they are encrypted with a key it does not hold. So the
// only place they can be cleaned is here, on the way out of decryption.
//
// Conservative by the same rule as the worker: only a trailing brace-blob that is recognisably
// envelope is dropped, because eating half of someone's sentence is the worse failure.

const ENVELOPE_KEY = /"(tool_calls|system_fingerprint|usage|finish_reason)"\s*:/;
const PADDING_KEY = /"p"\s*:\s*"[a-z0-9]{16,}"/i;

export function stripRuntimeArtifacts(text: string): string {
  let out = text;
  for (let pass = 0; pass < 3; pass++) {
    const cut = envelopeStart(out);
    if (cut < 0) break;
    out = out.slice(0, cut);
  }
  return out.trim();
}

/**
 * Where a trailing envelope begins, or -1. Candidate braces are tried right to left so a nested
 * one — `{"usage":{"total_tokens":40}}` — walks outwards to the brace that owns the whole blob.
 */
function envelopeStart(text: string): number {
  if (!text.trimEnd().endsWith('}')) return -1;
  let i = text.lastIndexOf('{');
  while (i >= 0) {
    const blob = text.slice(i);
    if (ENVELOPE_KEY.test(blob) || PADDING_KEY.test(blob)) return i;
    if (i === 0) break;   // lastIndexOf(_, -1) clamps to 0 and would loop here forever
    i = text.lastIndexOf('{', i - 1);
  }
  return -1;
}
